export const START_DRAFT_NOTIFICATION = 'spaces/publisher/draft/START'
export const SAVE_DRAFT_NOTIFICATION = 'spaces/publisher/draft/SAVE'
export const NAVIGATE_STEP_DRAFT_NOTIFICATION = 'spaces/publisher/draft/NAVIGATE'

export const RESET_DRAFT_NOTIFICATION = 'spaces/publisher/draft/RESET'
export const RESET_BULK_TARGETING_STATUS = 'spaces/publisher/targeting/bulk/RESET'

export const ADD_MEMBER_TO_DRAFT_NOTIFICATION_AUDIENCE = 'spaces/publisher/draft/audience/ADD'
export const REMOVE_MEMBER_FROM_DRAFT_NOTIFICATION_AUDIENCE = 'spaces/publisher/draft/audience/REMOVE'

export const FETCH_TARGETING_AGGREGATE_SUGGESTIONS = 'spaces/publisher/targeting/AGGREGATE'
export const FETCH_TARGETING_AGGREGATE_SUGGESTIONS_SUCCESS = `${FETCH_TARGETING_AGGREGATE_SUGGESTIONS}_SUCCESS`

export const FETCH_TARGETING_RULE_SET_SUGGESTIONS = 'spaces/publisher/targeting/RULESET'
export const FETCH_TARGETING_RULE_SET_SUGGESTIONS_SUCCESS = `${FETCH_TARGETING_RULE_SET_SUGGESTIONS}_SUCCESS`

export const RESOLVE_BULK_TARGETING_AGGREGATES = 'spaces/publisher/targeting/bulk/AGGREGATES'
export const RESOLVE_BULK_TARGETING_AGGREGATES_SUCCESS = `${RESOLVE_BULK_TARGETING_AGGREGATES}_SUCCESS`

export const RESOLVE_BULK_TARGETING_RULE_SETS = 'spaces/publisher/targeting/bulk/RULESET'
export const RESOLVE_BULK_TARGETING_RULE_SETS_SUCCESS = `${RESOLVE_BULK_TARGETING_RULE_SETS}_SUCCESS`
